import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import StatsForumMobile from '../../../pages/Mobile/Stats/StatsForumMobile';
import StatsForumDesktop from '../../../pages/StatsForumDesktop';

const StatsForumResponsive = () => {
    const { isMobile } = useResponsiveRedux(); 
    return isMobile ? <StatsForumMobile /> : <StatsForumDesktop />;
}; 

export default StatsForumResponsive;